export const evento = {
    DADOSEVENTO: 'DADOSEVENTO',
    PESQUISADADOSEVENTO: 'PESQUISADADOSEVENTO',
    EVENTOSELECTED: 'EVENTOSELECTED',
    CADASTRADO: 'CADASTRADO',
    DADOSWEBEVENTO: 'DADOSWEBEVENTO',
    FALECONOSCO: 'FALECONOSCO'
}